import styled from "styled-components";

import { actionBarStyle } from "./Styles";

const ActionBarStyled = styled.div`
    ${actionBarStyle};
`;
export const ActionBar = styled(ActionBarStyled).attrs(() => ({ className: "aevi-action-bar" as string }))``;
